<template>
  <Page>
    <Header />
    <div class="layout layout--sidebar-left">
      <main class="layout__main">
        <slot />
      </main>
      <slot name="sidebar-left" />
    </div>
  </Page>
</template>

<script>
import Page from '@/Theme/Layouts/Page.vue';
import Header from '@/Theme/Components/04-organisms/Header/Header.vue';

export default {
  name: 'LayoutSidebarLeft',
  components: {
    Page,
    Header,
  },
};
</script>

<style lang="scss">
  .layout {
    display: flex;
    flex-direction: column;
    @include media-breakpoint-up(md) {
      flex-direction: row;
    }
    &__main {
      flex-basis: 100%;
      order: 3;
      @include media-breakpoint-up(md) {
        position: relative;
      }
    }
    &__sidebar {
      top: 0;
      width: 100%;
      padding: 2rem;
      overflow: auto;
      @include media-breakpoint-up(md) {
        margin-top: 0;
        position: relative;
        width: auto;
        flex-grow: 1;
        flex-shrink: 0;
        flex-basis: 25rem;
        max-width: 30rem;
      }
    }
    &--sidebar-left {
      flex: 1;
      overflow: hidden;
      position: relative;
    }
  }
</style>
